// Seperate store to just hold UI Stuff

import { createWithEqualityFn as create } from 'zustand/traditional';
import { createJSONStorage, persist } from 'zustand/middleware';
import { RegistrationViewType } from '@models/RegistrationViewType';
import produce from 'immer';
import { AutoMatchActionType } from '@models/MatchActionType';
import { Sorting } from '../models/ISorting';
import { Language } from '../models/Languages';
import { ViewColoring, ViewIndicators } from '../models/Accessibility';

export type PersistentStore = {
  registrationView: RegistrationViewType;
  privacyEnabled: boolean;
  autoMarking: AutoMatchActionType;
  doubleMarking: boolean;
  tooltips: boolean;
  emailReminder: boolean;
  studentSort: string;
  urlQuery: any;
  language: any;
  tutorial: boolean;
  viewColoring: any;
  viewIndicators: any;
  pictures: any;
  defaultQr: boolean,
  setPersistentStore: (fn: (draft: PersistentStore) => void) => void;
};

// this is a bit cramped together, but for now

const persistentStore = create<PersistentStore>()(
  persist(
    (set) => ({
      registrationView: RegistrationViewType.CARD,
      autoMarking: AutoMatchActionType.NONE,
      privacyEnabled: false,
      doubleMarking: false,
      tooltips: true,
      emailReminder: false,
      urlQuery: {},
      studentSort: Sorting.ALPHA_ASC,
      language: Language.DANISH,
      tutorial: true,
      viewColoring: ViewColoring.DEFAULT,
      viewIndicators: ViewIndicators.COLOR,
      pictures: true,
      defaultQr: false,
      setPersistentStore: (fn) => {
        return set(produce(fn));
      },
    }),
    {
      name: 'attenderStorage_demo',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default persistentStore;
